import { formatHoursMinutesSeconds } from '@fabric-app/utils/number';

const getAnnotationText = (annotation) => {
  if (!annotation) return null;
  if (annotation.notepad) {
    return {
      text: annotation.notepad.text,
      quoted: true
    };
  }
  if (annotation.audioVideo) {
    return {
      text: `${formatHoursMinutesSeconds(annotation.audioVideo.startTime)} – ${formatHoursMinutesSeconds(annotation.audioVideo.endTime)}`,
      quoted: false
    };
  }
  if (annotation.text) {
    return {
      text: annotation.text.text,
      quoted: true
    };
  }
  return null;
};

export { getAnnotationText };
//# sourceMappingURL=getAnnotationText.js.map
